import { Column } from 'react-table';

import { ActionsCell } from 'app/components/Table/columns/ActionsCell';
import { CustomHeader } from 'app/components/Table/columns/CustomHeader';
import { ActionTable, ID, TYPE_MODAL } from 'app/components/Table/core/types';
import Typography from 'app/components/Typography';

import { formatCustomDate } from 'app/helpers';

import { Ward } from './type';

export const wardsColumns = (
  isSystemAdminCurrent: boolean,
  handleDownloadTemperature: (wardId: ID) => () => void,
): ReadonlyArray<Column<Ward>> => {
  const actions = (ward: Ward) =>
    [
      {
        name: 'Edit',
        type: TYPE_MODAL.EDIT,
      },
      isSystemAdminCurrent && {
        name: 'Archive',
        type: TYPE_MODAL.DELETE,
        titleModal: 'Archive location',
      },
      isSystemAdminCurrent && {
        name: 'Export temperature',
        type: TYPE_MODAL.NONE,
        titleModal: TYPE_MODAL.NONE,
        onClick: handleDownloadTemperature(ward?.id),
      },
    ].filter(Boolean) as ActionTable[];

  return [
    {
      id: 'name',
      accessor: 'name',
      width: '60%',
      Header: (props) => <CustomHeader tableProps={props} title="Name" />,
    },
    // {
    //   id: 'bedQuantity',
    //   accessor: 'countChildren',
    //   width: '20%',
    //   Header: 'Bed quantity',
    //   Cell: ({ ...props }) => (
    //     <Typography variant="body-5" color="neutral-10">
    //       {props.data[props.row.index].countChildren ?? 0}
    //     </Typography>
    //   ),
    // },
    // {
    //   id: 'connectionStatus',
    //   Header: 'Raspberry Pi connection',
    //   Cell: ({ ...props }) => (
    //     <HeartBeatStatus pageType="ward" targetId={Number(props.data[props.row.index].id)} />
    //   ),
    // },
    {
      id: 'rackCount',
      accessor: 'rackCount',
      width: '15%',
      Header: (props) => <CustomHeader tableProps={props} title="Number of racks" />,
    },
    {
      id: 'createdAt',
      width: '20%',
      Header: (props) => <CustomHeader tableProps={props} title="Created at" />,
      Cell: ({ ...props }) => (
        <Typography lineHeight={26} variant="body-1">
          {formatCustomDate(props.data[props.row.index]['createdAt'])}
        </Typography>
      ),
    },
    {
      id: 'actions',
      width: '5%',
      Header: (props) => (
        <CustomHeader tableProps={props} title="" className="text-end min-w-100px" />
      ),
      Cell: ({ ...props }) => (
        <>
          <div className="d-flex" style={{ gap: 12 }}>
            {/* <div
              style={{
                display: 'flex',
                width: 38,
                height: 38,
                alignItems: 'center',
                justifyContent: 'center',
                background: 'white',
                borderRadius: 8,
                border: '1px solid var(--neutral-3)',
                cursor: 'pointer',
              }}
              onClick={() =>
                navigate(PATH.WARDS_LAYOUT.replace(':id', String(props.data[props.row.index].id)))
              }
            >
              <GridIcon />
            </div> */}
            <ActionsCell
              item={props.data[props.row.index]}
              actions={actions(props.data[props.row.index])}
            />
          </div>
        </>
      ),
    },
  ];
};
